export class InstantCallRequest {
  constructor(data = {}) {
    this.id = data.id || "";
    this.fullName = data.fullName || "";
    this.phoneNumber = data.phoneNumber || "";
    this.countryCode = data.countryCode || "+971";
    this.requestedAt = data.requestedAt
      ? new Date(data.requestedAt)
      : new Date();
    this.status = data.status || "new";
    this.propertyId = data.propertyId || null;
  }

  static fromJson(json) {
    return new InstantCallRequest(json);
  }

  toJson() {
    return {
      id: this.id,
      fullName: this.fullName,
      phoneNumber: this.phoneNumber,
      countryCode: this.countryCode,
      // Store date as ISO string for consistent Firestore saving
      requestedAt: this.requestedAt.toISOString(),
      status: this.status,
      propertyId: this.propertyId,
    };
  }
}
